import styled from 'styled-components'
import {mediumFont} from '../../../../../theme/font-styles'

export const Title = styled.h1`
    ${mediumFont()}
    margin: 0;
    padding: 0;
    text-align: center;
`
